import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FormGroup } from "react-bootstrap";
import SettingViewItem from "./SettingViewItem";
import toast, { Toaster } from "react-hot-toast";

const ScheduleSettingViews = ({ showLabel = true, widgetViews, onChange }) => {
    const [views, setViews] = useState([]);

    useEffect(() => {
        setViews(widgetViews);
    }, [widgetViews]);

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedList = reorder(
            views,
            result.source.index,
            result.destination.index,
        );

        handleUpdateOrder(reorderedList);
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    const handleUpdateOrder = (list) => {
        setViews(list);
        onChange({scheduleViews: list});
    };

    const handleChangeValue = (name, query) => {
        const list = [...views];
        let index = 0;

        list.forEach((item, i) => {
            if (item.value === name) {
                item.show = query;
                index = i;
            }

            if (!list.some(({show}) => show)) {
                toast.error('Должен быть выбран хотя бы один вид отображения', {
                    duration: 5000,
                });
                list[index].show = true;
            }
        });

        setViews(list);
        onChange({scheduleViews: list});
    };

    return (
        <FormGroup>
            {showLabel && (
                <p>Вид отображения:</p>
            )}
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {views?.map((item, index) => (
                                <Draggable
                                    key={item.value}
                                    draggableId={`${item.value || index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={
                                                provided.draggableProps.style
                                            }
                                        >
                                            <SettingViewItem
                                                key={item.value}
                                                item={item}
                                                onChange={handleChangeValue}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            <Toaster position="top-right" />
        </FormGroup>
    );
};

export default ScheduleSettingViews;
